import { Provider } from '@angular/core';

import { BhApi } from '@mark/web-contracts';

import { CommonGrpcContractFactory } from './common.service.provider';

export const ActionsPlanBhGrpcContractProvider: Provider = {
  provide: BhApi.ActionsPlanBhGrpcContractClient,
  useFactory: CommonGrpcContractFactory(BhApi.ActionsPlanBhGrpcContractClient),
};
